import { ReactElement } from 'react'

import DetalhesTermosUso from 'modules/termosUso/pages/DetalhesTermosUso'
import Find from 'shared/modules/termosUso/domain/usecases/Find'
import TermosUsoRepository from 'shared/modules/termosUso/infra/repositories/TermosUsoRepository'

export const TermosUsoFactory = (): ReactElement => {
  const termosUsoRepository = new TermosUsoRepository()
  const findImpl = new Find(termosUsoRepository)

  return <DetalhesTermosUso find={findImpl} />
}
